import { useEntitlements } from "./useEntitlements";

/**
 * Whether the account holds the Next Gen Zaps billing entitlement.
 *
 * Only a plain `true` passes, so a `false` value, an absent key, an absent
 * entitlements block and an in-flight query all read as not entitled. The
 * monolith's dotted `workflow.next_gen_zaps_enabled` arrives camelCased, and
 * this is the only place that spelling is relied on.
 *
 * `isNextGenZapsEntitlementKnown` is true once the query has answered, entitled
 * or not.
 */
export function useIsNextGenZapsEntitled() {
  const { entitlements, isLoading, isError, error } = useEntitlements();

  return {
    isNextGenZapsEntitled:
      entitlements?.entitlements?.workflowNextGenZapsEnabled?.value === true,
    isNextGenZapsEntitlementKnown: entitlements !== undefined,
    isLoading,
    isError,
    error,
  };
}
